import React from "react";
import { Link } from "react-router-dom";
import Logo from "images/iq/iq_logo.svg";

const IQHeader = () => {
  return (
    <header className="py-3 md:py-5 px-6 md:px-8 flex justify-between items-center bg-black">
      <div className="mr-4 ml-1 lg:mr-12 pb-1">
        <Link to="/">
          <img
            alt="logo"
            src={Logo}
            className="w-32 md:w-48"
            style={{ height: "auto", minWidth: "150px" }}
          />
        </Link>
      </div>
    </header>
  );
};

export default IQHeader;
